module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-kia.13fe335d.png";